<template>
  <div class="relative">
    <!-- Opener -->
    <button class="w-max flex items-center p-1.5 rounded-md transition-colors duration-100"
    :class="showDropdown ? 'bg-neutral-25' : 'hover:bg-neutral-25'"
    @click="showDropdown = !showDropdown">
      <HookLiveStatusIcon :status="selection.key" />
      <BaseText type="label" size="sm" class="text-text-muted px-1">
        {{ selection.label }}
      </BaseText>
      <ChevronIcon class="text-icon-normal transform transition-transform duration-100"
      :style="{ transform: showDropdown ? 'scaleY(-1)' : 'scaleY(1)' }" />
    </button>
    <!-- Dropdown -->
    <transition>
      <div v-if="showDropdown" class="dropdown-container" v-on-clickaway="() => { showDropdown = false }">
        <button v-for="option in options" :key="`status-option-${option.key}`"
        class="w-full flex items-center p-1.5 rounded-md transition-colors duration-100"
        :class="option.isActive ? 'bg-neutral-25 text-text-muted' : 'text-text-normal hover:bg-neutral-25 hover:text-text-muted'"
        @click="handleSelection(option)">
          <HookLiveStatusIcon :status="option.key" />
          <BaseText type="label" size="sm" class="px-1">
            {{ option.label }}
          </BaseText>
          <div class="w-5 h-5 ml-auto">
            <CheckmarkIcon v-if="option.isActive" class="text-icon-normal" />
          </div>
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway2'

// Icons
import HookLiveStatusIcon from '../../globals/Icons/SpyderV2Icons/HookLiveStatusIcon.vue'
import ChevronIcon from '../../globals/Icons/ChevronIcon.vue'
import CheckmarkIcon from '../../globals/Icons/NewCheckmarkIcon.vue'

export default {
  name: 'LiveStatusDropdown',
  mixins: [clickaway],
  components: {
    HookLiveStatusIcon,
    ChevronIcon,
    CheckmarkIcon
  },
  props: {
    liveStatus: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      showDropdown: false
    }
  },
  computed: {
    options () {
      return [
        { 
          key: 'live', 
          label: 'Live Ads', 
          value: ['live'],
          isActive: this.liveStatus?.[0] === 'live'
        },
        { 
          key: 'dead', 
          label: 'Dead Ads', 
          value: ['dead'],
          isActive: this.liveStatus?.[0] === 'dead'
        },
        { 
          key: 'all', 
          label: 'All Ads', 
          value: null,
          isActive: !this.liveStatus 
        }
      ]
    },
    selection () {
      return this.options.find(option => option.isActive) || this.options[0]
    }
  },
  methods: {
    handleSelection (option) {
      this.$emit('update:live-status', option.value)
      this.showDropdown = false
    }
  }
}
</script>

<style scoped>
.dropdown-container {
  position: absolute;
  top: calc(100% + 6px);
  left: 0px;
  width: 182px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  border-radius: 10px;
  padding: 4px;
  background-color: white;
  box-shadow: 0 12px 16px -8px rgba(24, 35, 68, 0.04), 0 2px 4px -1.5px rgba(24, 35, 68, 0.04), 0 1px 2px -0.75px rgba(24, 35, 68, 0.04), 0 0 0 1px rgba(0, 40, 136, 0.08);
  z-index: 1000;
}

.v-enter-active, .v-leave-active {
  transition: opacity 75ms ease-in-out;
}
.v-enter-from, .v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave-from {
  opacity: 1;
}
</style>